import { Workspace } from "@/components/graphql/schema.graphql";

type PermissionWorkspace = Pick<
  Workspace,
  "enableWorkspaceHierarchy" | "isChildWorkspace"
> & { myPermissions: string[] };

const BASIC_WORKSPACE_PERMISSION = "workspace:basic";

export const hasUsablePermissions = (workspace: {
  myPermissions: string[];
}): boolean => {
  return workspace.myPermissions.some((p) => p !== BASIC_WORKSPACE_PERMISSION);
};

const MEMBER_ONLY_PERMISSIONS = new Set([
  "workspace:basic",
  "project:view",
  "workspace:labels:assign",
]);

export const isHiddenHierarchyParent = (
  workspace: PermissionWorkspace,
): boolean => {
  return (
    workspace.enableWorkspaceHierarchy === true &&
    workspace.isChildWorkspace === false &&
    workspace.myPermissions.every((p) => MEMBER_ONLY_PERMISSIONS.has(p))
  );
};
